var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-button",style:({ color: _vm.textColor }),attrs:{"tag":"div","to":_vm.to}},[_vm._t("default"),_vm._v(" "),(_vm.bottomLine)?_c('span',{staticClass:"link-button__buttom-line"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }